import { uploadAvatarOpenComponent } from './upload-avatar.components';
import { uploadAvatarService } from './upload-avatar.service';

export const uploadAvatarModule = angular
  .module('uploadAvatarModule', [])
  .service('$uploadAvatar', uploadAvatarService)
  .component('uploadAvatarOpen' , uploadAvatarOpenComponent);


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/upload-avatar/upload-avatar.js
 **/